<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// vuex
import { mapMutations } from 'vuex'
export default {
  mounted() {
	  // 给所有a标签设置不可点击
	  var a = document.querySelectorAll('a');
	  for(let i=0; i<a.length;i++) {
		if(!a[i].getAttribute('href')){
			a[i].setAttribute('href', 'javascript:;');
		}
	  }
  },
  created() {
	  // 调用获取公共属性方法
	  this.getAllCategory();
	  if(localStorage.getItem('member')) {
		  this.changeState({
			  member: JSON.parse(localStorage.getItem('member'))
		  })
	  }
  },
  
  methods: {
	  // vuex
	  ...mapMutations(['changeState', 'getAllCategory']),
  }
}
</script>

<style lang="less">
/*
* 公共样式类
*/

@charset "utf-8";

* {
	padding: 0;
	margin: 0;
	vertical-align: top;
	
	line-height: 1;
	list-style: none;
	border: 0;
	background: none;
	box-sizing: border-box;
	word-break: break-word;
}

/*声明 WebFont*/
@font-face {
	font-family: "Regular";
	src: url("@/fonts/HarmonyOs_Sans_SC_Regular.ttf");
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: "Light";
	src: url("@/fonts/HarmonyOs_Sans_SC_Light.ttf");
	font-weight: normal;
	font-style: normal;
}
@font-face {
	font-family: "Medium";
	src: url("@/fonts/HarmonyOs_Sans_SC_Medium.ttf");
	font-weight: normal;
	font-style: normal;
}
.ql-snow.ql-toolbar button{
	line-height:1;
}
.quill-editor {
    background: #fff;
}
.ql-clean:after {
    font-family: element-icons!important;
    content: "\e7c3";
    font-size: 125%;
}
.ql-clean svg {
    display:none !important;
}
// @font-face {
// 	font-family: "Regular";
// 	src: url("../fonts/HarmonyOs_Sans_SC_Regular.ttf");
// 	font-weight: normal;
// 	font-style: normal;
// }
// @font-face {
// 	font-family: "Alimama";
// 	src: url("../fonts/alimama_Bold.ttf");
// 	font-weight: normal;
// 	font-style: normal;
// }
// @font-face {
// 	font-family: "DINCond";
// 	src: url("../fonts/DINCond-Bold.otf");
// 	font-weight: normal;
// 	font-style: normal;
// }

h1,
h2,
h3,
h4,
h5,
h6 {
	line-height: 1.3;
	font-size: 0.2rem;
}

html{
	font-size: calc(100 / 1920 * 100vw);
}


.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
	font-weight: 400;
	font-size: 0.16rem;
	line-height: 1.3;
}

body {
	color: #333;
	font-family: "Regular", "arial", "sans-serif";
	overflow-x: hidden;
	font-size: 0.16rem;
}

body.y-hidden {
	overflow-y: hidden;
}

i,
em {
	font-style: normal;
}

a {
	text-decoration: none;
	color: #333;
}

img {
	max-width: 100%;
}

textarea {
	resize: none;
}

select {
	appearance: none;
	-moz-appearance: none;
	-webkit-appearance: none;
}

select,
input,
button,
textarea {
	color: #333;
	font-size: 0.16rem;
	font-family: "Regular", "arial", "sans-serif";
	outline: none;
}

::-webkit-input-placeholder {
	/* WebKit browsers */
	color: #818181;
}

:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #818181;
}

::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #818181;
}

:-ms-input-placeholder {
	/* Internet Explorer 10+ */
	color: #818181;
}


/* ***********************************************
					公共样式类
*********************************************** */
.link:hover{
	color: #2657db;
}
.pr {
	position: relative;
}

.ab {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 5;
}

.sizing {
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
}

.hidden {
	display: none;
}

.j-end {
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
}

.j-center {
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.j-sb {
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.j-start {
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
}

.f-wrap {
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.f-colu {
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
}

.a-center {
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.a-start {
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.a-end {
	-webkit-box-align: end;
	    -ms-flex-align: end;
	        align-items: flex-end;
}

.nowrap1 {
	overflow: hidden;
	-o-text-overflow: ellipsis;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.nowrap2 {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.nowrap3 {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;

}

.pointer:hover {
	cursor: pointer;
}

.t-center {
	text-align: center;
}

/* 行高 */
.line-mn,
.line-mn * {
	line-height: 1.3;
}

.line-sm,
.line-sm * {
	line-height: 1.5;
}

.line-md,
.line-md * {
	line-height: 1.8;
}

.line-lg,
.line-lg * {
	line-height: 2;
}

/* 字体 */
.font-heavy{
	font-weight: 900;
}
.font-medium{
	font-family: "Medium";
}
.font-regular{
	font-family: "Regular";
}
.font-light{
	font-family: "Light";
}
.font-alimama{
	font-family: "Alimama";
}
.font-dincond{
	font-family: "DINCond";
}
.font12 {
	font-size: 0.12rem;
}

.font14 {
	font-size: 0.14rem;
}

.font16 {
	font-size: 0.16rem;
}

.font18 {
	font-size: 0.18rem;
}

.font20 {
	font-size: 0.20rem;
}

.font22 {
	font-size: 0.22rem;
}

.font24 {
	font-size: 0.24rem;
}

.font25 {
	font-size: 0.25rem;
}

.font26 {
	font-size: 0.26rem;
}

.font28 {
	font-size: 0.28rem;
}

.font30 {
	font-size: 0.3rem;
}

.font32 {
	font-size: 0.32rem;
}

.font34 {
	font-size: 0.34rem;
}

.font35 {
	font-size: 0.35rem;
}

.font36 {
	font-size: 0.36rem;
}

.font40 {
	font-size: 0.4rem;
}

.font42 {
	font-size: 0.42rem;
}

.font45 {
	font-size: 0.45rem;
}

.font46 {
	font-size: 0.46rem;
}

.font48 {
	font-size: 0.48rem;
}

.font50 {
	font-size: 0.5rem;
}

.font55 {
	font-size: 0.55rem;
}

.font56 {
	font-size: 0.56rem;
}

.font60 {
	font-size: 0.6rem;
}

.font65 {
	font-size: 0.65rem;
}

.font100 {
	font-size: 1rem;
}

.font-bold {
	font-weight: 700;
}

/* 网站常用类 */

/* 颜色 */
.corfff {
	color: #fff;
}
.cor265{
	color: #2657db;
}
.cor666{
	color: #666;
}
.cor333 {
	color: #333;
}
.cor999 {
	color: #999;
}
.corF5F6F4 {
	color: #F5F6F4;
}

.corB4B4B4 {
	color: #B4B4B4;
}

.cor818181 {
	color: #7a7e87;
}

.cor3C3C3C {
	color: #3C3C3C;
}

.cor5a5a5a {
	color: #5a5a5a;
}
.opacity0 {
	opacity: 0;
}

.clearfix:after {
	content: '';
	height: 0;
	line-height: 0;
	display: block;
	visibility: hidden;
	clear: both;
}

.mask {
	background-color: rgba(0, 0, 0, .6);
	display: none;
}

.t-sion {
	-webkit-transition: all .5s ease;
	-o-transition: all .5s ease;
	transition: all .5s ease;
}

.underline:hover {
	text-decoration: underline !important;
}

.d-block {
	display: block;
}

.d-flex {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}
.w1600{
	max-width: 1600px;
	width: 95%;
	margin: 0 auto;
	
}
.w100{
	width: 100%;
}

/* 一些公共样式 */
.handleType{
	position: fixed;
	left: .3rem;
	bottom: .5rem;
	width: 1rem;
	height: .4rem;
	border-radius: .4rem;
	border: solid 5px #fff;
	background: #fff;
	box-shadow: 2px 2px 5px rgba(0,0,0,.3);
	display: none;
	z-index: 5;
	img{
		width: .25rem;
		margin-left: .1rem;
	}
	@media (max-width: 1200px) {
		display: flex;
	}
}
.conmonContent{
	background: #edf0f2 url(@/assets/Home/productBg.png) no-repeat center 0/100%;
	background: linear-gradient(180deg, #263c94, #edf0f2 289px);
	border-top: solid 1px transparent;
	padding-bottom: .8rem;
	@media (max-width: 750px) {
		background-image: url(@/assets/Home/productBgPhone.png);
		background: linear-gradient(180deg, #263c94, #edf0f2 289px);

	}
}
.cTopFrom{
	width: 5.8rem;
	max-width: 100%;
	border-radius: 5px;
	overflow: hidden;
	margin: 0.5rem auto;
	background-color: #fff;
	.select{
		background:  url(@/assets/Icons/formLine.png) no-repeat right center/auto 0.2rem;
	}
	.select select{
		width: 1.2rem;
		height: .5rem;
		padding: 0 0 0 0.2rem;
		background:  url(@/assets/Icons/arrowDownBlack.png) no-repeat .95rem center/0.12rem;
	}
	.from{
		width: calc(100% - 1.2rem);
		.t{
			display: block;
			width: 100%;
			padding: 0 .6rem 0 .2rem;
			height: .5rem;
		}
		.s{
			position: absolute;
			right: 0;
			top: 0;
			height: 100%;
			width: .6rem;
			z-index: 2;
			background:  url(@/assets/Icons/search.png) no-repeat center/0.18rem;
			&:hover{
				background: #2147d7 url(@/assets/Icons/searchWhite.png) no-repeat center/0.18rem;
			}
		}
	}
}
.sTitle{
	margin-bottom: .25rem;
	img{
		height: 0.25rem;
		margin-right: .15rem;
		padding-top: 5px;
	}
}
.tagList i{
	padding: 0.05rem 0.08rem;
	border-radius: 0.15rem;
	background: #5794f8;
	color: #fff;
	margin-right: 5px;
	margin-bottom: 5px;
	&.type{
		background: none;
		color: #2657db;
		border: solid 1px #2657db;
	}
}
.p3{
	padding: .3rem;
}
.oTitle {
	border-bottom: solid 1px #eee;
	margin-bottom: .3rem;
	h4{
		position: relative;
		padding-bottom: .2rem;
		
		&:after{
			content: "";
			position: absolute;
			left: 0;
			bottom: -1px;
			width: 100%;
			height: 1px;
			background: #2048d7;
			max-width: .8rem;
		}
	}
	
}
.pageTurning{
	a{
		color: #333;
		max-width: calc(100% - 1rem);
	}
	p{
		width: 49%;
		&:nth-of-type(2) {
			justify-content: flex-end;
		}
 	}
	@media (max-width: 640px) {
		display: block;
		p{
			width: 100%;
			&:nth-of-type(1) {
				margin-bottom: .2rem;
			}
 		}
	}
}
.conmonDocument{
	h3{
		padding-left: .3rem;
		&.pdf{
			background:  url(@/assets/Icons/pdf.png) no-repeat 0 0/0.18rem;
		}
		&.file{
			background:  url(@/assets/Icons/file.png) no-repeat 0 0/0.18rem;
		}
		&.que{
			background:  url(@/assets/Icons/questionIcon.png) no-repeat 0 .07rem/0.18rem;
		}
	}
}
.scale{
	&:hover{
		figure img{
			transform: scale(1.05);
		}
	}
	figure{
		overflow: hidden;
		img{
			width: 100%;
		}
	}
}
.naList{
	ul{
		margin: 0 -.1rem;
		margin-top: -.2rem;
		li{
			padding: 0 .1rem;
			margin-top: .2rem;
			width: 25%;
			.text{
				background: #fff;
				border-radius: .1rem;
				overflow: hidden;
				figure{
					position: relative;
					a{
						display: block;
						width: 1rem;
						border-radius: 3px;
						height: .4rem;
						background: #2147d7;
						color: #fff;
						text-align: center;
						line-height: .4rem;
						position: absolute;
						left: .2rem;
						top: .2rem;
						z-index: 5;
						&:hover,&.entry{
							background: #ff8400;
							color: #fff;
						}
						&.entry.gray{
							background: #999;
						}
						&:not(:last-child) {
							margin-right: .1rem;
						}
					}
				}
			}
			.intro{
				padding: .3rem;
			}
			p{
				margin: .15rem 0 .2rem;
			}
			.date{
				padding-left: .25rem;
				background:  url(@/assets/Icons/icon-date.png) no-repeat 0 center/0.16rem;
				margin-bottom: 10px;
				span{
					color: #333;
					padding-right: 5px;
				}
			}
			.date1{
				padding-left: .25rem;
				background:  url(@/assets/Icons/icon-date1.png) no-repeat 0 2px/0.16rem;
				margin-bottom: 10px;
				span{
					color: #999;
					padding-right: 5px;
				}
			}
			.date2{
				padding-left: .25rem;
				background:  url(@/assets/Icons/icon-date2.png) no-repeat 0 2px/0.16rem;
				margin-bottom: 10px;
				span{
					color: #999;
					padding-right: 5px;
				}
			}
			.type{
				padding-left: .25rem;
				background:  url(@/assets/Icons/icon-type.png) no-repeat 0 2px/0.16rem;
				span{
					color: #999;
					padding-right: 5px;
				}
			}
			.handel{
				margin-top: .15rem;
				padding-top: .2rem;
				border-top: solid 1px #f1f1f1;
				span{
					padding-left: .22rem;
					background:  url(@/assets/Icons/view.png) no-repeat 0 3px/0.18rem;
				}
				a{
					display: block;
					width: 1rem;
					border-radius: 3px;
					height: .4rem;
					background: #2147d7;
					color: #fff;
					text-align: center;
					line-height: .4rem;
					&:hover,&.entry{
						background: #2147d7;
						color: #fff;
					}
					&.entry.gray{
						background: #999;
					}
					&:not(:last-child) {
						margin-right: .1rem;
					}
				}
			}
		}
	}
	@media (max-width: 1200px) {
		ul{
			li{
				width: 50%;
				.btns{
					flex-direction: column;
					a{
						margin: 0;
						&:nth-of-type(1) {
							margin-bottom: .1rem;
						}
					}
				}
			}
		}
	}
	@media (max-width: 640px) {
		ul{
			li{
				.intro{
					padding: .1rem;
				}
				
			}
		}
	}
}
.bd10{
	border-radius: .1rem;
	background: #fff;
	overflow: hidden;
}
.disc{
	padding-left: .15rem;
	position: relative;
	&:after{
		content: "";
		position: absolute;
		left: 0;
		top: .1rem;
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background: #2045d6;
	}
}
.input{
	background: #f5f6f8;
	border-radius: 5px;
	padding: 0 .2rem;
	width: 100%;
	height: .5rem;
}
select.input,.select.input{
	padding-right: .5rem;
	background: #f5f6f8 url(@/assets/Icons/arrowDownWeight.png) no-repeat 95% center/0.1rem;
}
.fmBtn{
	height: .5rem;
	text-align: center;
	line-height: .5rem;
	border-radius: 5px;
	background: #294ad3;
	color: #fff;
	&:hover{
		box-shadow: 2px 2px 3px rgba(41,74,211,.6);
	}
}
.checkbox{
	width: .2rem;
	height: .2rem;
	background-color: #fff;
	border-radius: 3px;
	margin-right: .1rem;
	&.active,&:hover{
		background: #fff url(@/assets/Icons/checked.svg) no-repeat center/100%;
	}
}
.interest{
	ul{
		li{
			width: 20%;
			padding-right: .1rem;
			margin-top: .2rem;
			padding-left: .25rem;
			position: relative;
			&:hover,&.active{
				p{color: #2657db;font-weight: 700;}
				span{background: #2657db;}
				span:after{
					content: "";
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%,-50%);
					width: .06rem;
					height: .06rem;
					background-color: #fff;
					border-radius: 50%;
				}
			}
			span{
				position: absolute;
				left: 0;
				top: 2px;
				width: .18rem;
				height: .18rem;
				border-radius: 50%;
				background: #e2e5ec;
			}
		}
	}
}
.swich{
	width: .6rem;
	height: .3rem;
	border-radius: .3rem;
	background: #e9ecf3;
	&.active{
		background: #2045d6;
		span{
			right: .3rem;
		}
	}
	span{
		position: absolute;
		right: .05rem;
		width: .25rem;
		height: .24rem;
		border-radius: .24rem;
		background: #fff;
		top: 50%;
		transform: translateY(-50%);
	}
}

.el-popover__title{
	font-size: .16rem !important;
}

// 上传
.el-upload{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 5;
	opacity: 0;
}

// 分页
.pagination{
	margin-top: .4rem;
	display: flex;
	justify-content: center;
	.el-pager li{
		width: .4rem;
		height: .4rem;
		border-radius: 5px;
		background: #fff;
		margin: 0 .05rem;
		color: #666;
		text-align: center;
		line-height: .4rem;
		&:hover,&.active{
			background: #2657db;
			color: #fff;
		}
	}
	.el-pagination{
		button{
			width: .4rem;
			height: .4rem;
			border-radius: 5px;
			padding: 0;
			i.el-icon{
				display: none;
			}
			&.btn-next{
				
				background: #fff url(@/assets/Icons/next.png) no-repeat center/5px;
				&:hover{
					background: #2657db url(@/assets/Icons/nextWhite.png) no-repeat center/5px;
				}
			}
			&.btn-prev{
				background: #fff url(@/assets/Icons/prev.png) no-repeat center/5px;
				&:hover{
					background: #2657db url(@/assets/Icons/prevWhite.png) no-repeat center/5px;
				}
			}
		}
		
	}
	
}

@media (min-width: 1921px) {
	html{
		font-size: 100px;
	}
}

@media (max-width: 1600px) {
	html{
		font-size: calc(100 / 1500 * 100vw);
	}
}
@media (max-width: 1200px) {
	html{
		font-size: 10vw;
	}
	.font36 {
	    font-size: 0.32rem;
	}
}
@media (max-width: 700px) {
	html{
		font-size: 14vw;
	}
}
@media (max-width: 640px) {
	html{
		font-size: 20vw;
	}
	.font36 {
	    font-size: 0.30rem;
	}
	.font30 {
	    font-size: 0.24rem;
	}
}
.el-progress-bar__inner {
    background: #2657db;
}

.el-progress {
	display: flex;
	max-width: 100px;
	align-items: center;
	flex: 1 1 auto;
	margin: auto;
}
.el-progress  .el-progress-bar{
	flex: 1 1 auto;
	overflow: hidden;
	width: auto;
	margin-right: 0;
	width: auto;
	padding-right: 0;
}
.el-progress__text{
	flex: 0 0 auto;
}
.downbar{
	margin-top: 10px;
}
.downbar .el-progress {
    margin: 0;
}
.pdfdialog .el-dialog {
    max-width: 1024px;
    margin: 0 auto;
}

.passwordLevel {
    margin-top: 10px;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
	line-height: 1;
	min-height: 1em;
}

.passwordLevel .lv {
    flex: 1 1 auto;
    justify-content: space-between;
    align-items: center;
    margin-right: 1em;
    max-width: 110px;
}

.passwordLevel .lv i {
    flex: 0 0 auto;
    width: 32%;
    height: 2px;
}
.passwordLevel .lv i:nth-child(1) {
    background: #ff4e4e;
}
.passwordLevel .lv i:nth-child(2) {
    background: #eb9a10;
}

.passwordLevel .lv i:nth-child(3) {
    background: #00ca0b;
}
.passwordLevel.l1 .lv i:nth-child(2),.passwordLevel.l1 .lv i:nth-child(3){
	background: #ccc;
}
.passwordLevel.l2 .lv i:nth-child(3){
	background: #ccc;
}
.passwordLevel .lt {
    flex: 0 0 auto;
}

.passwordLevel .lt span {
    display: none;
}
.passwordLevel.l1 .lt span:nth-child(1){
	display: block;
}
.passwordLevel.l2 .lt span:nth-child(2){
	display: block;
}
.passwordLevel.l3 .lt span:nth-child(3){
	display: block;
}
</style>
